<script>
    export let inline = false;
    export let callback = () => {};
    export let isChecked = false;
    export let isDisabled = false;
    export let label = '';
    export let parentGroup;
    export let rightAlignedText = null;
    export let subText = null;
    export let tooltip = null;
    export let value;
    export let isSmall = false;

    const cid = _.uniqueId();

    function handleChange(event) {
        if (callback) {
            callback(parseInt(event.target.value));
        }
    }
</script>

<label
    id={cid}
    class="radiobtn"
    class:radiobtn--inline={inline}
    class:is-small={isSmall}
    title={tooltip}
>
    <input
        type="radio"
        name={parentGroup}
        {value}
        on:change={handleChange}
        disabled={isDisabled}
        checked={isChecked}
    />
    <span class="radiobtn__dot"><div></div></span>
    <span class="label-container">
        <span class="label">
            <slot name="label">
                {label}
            </slot>
        </span>
        {#if subText}
            <span class="sub-text">{subText}</span>
        {/if}
    </span>
    <slot name="right">
        {#if rightAlignedText}
            <span class="right-aligned-text">{rightAlignedText}</span>
        {/if}
    </slot>
</label>

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
.radiobtn {
  --size: 24px;
  --dot-size: 10px;
  --spacing-right: 16px;
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.radiobtn--inline {
  display: inline-flex;
  margin-right: 16px;
  min-height: 32px;
}
.radiobtn__dot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: var(--size);
  min-width: var(--size);
  height: var(--size);
  margin-right: var(--spacing-right);
  background: #fff;
  border: 1px solid #9a9bb5;
  border-radius: 50%;
}
.radiobtn__dot > div {
  width: var(--dot-size);
  height: var(--dot-size);
  border-radius: inherit;
}
.radiobtn input {
  position: absolute;
  opacity: 0;
  z-index: -1;
  cursor: pointer;
}
.radiobtn input:disabled ~ * {
  opacity: 0.4;
  cursor: not-allowed;
}
.radiobtn input:checked ~ .radiobtn__dot {
  background-color: hsl(205, 60%, 44%);
  border-color: hsl(205, 60%, 44%);
}
.radiobtn input:checked ~ .radiobtn__dot > div {
  background-color: #fff;
}
.radiobtn input:focus ~ .radiobtn__dot {
  box-shadow: 0 0 10px 0 rgba(44.88, 123.42, 179.52, 0.5);
}
.radiobtn.is-small {
  --size: 20px;
  --dot-size: 8px;
  --spacing-right: 8px;
}

.label-container {
  flex-grow: 1;
}

.label {
  display: block;
}

.sub-text {
  display: block;
  margin-top: 2px;
  color: #9a9bb5;
}

.right-aligned-text {
  color: #9a9bb5;
  text-align: right;
  margin-left: 8px;
}</style>
